import { RootState } from '../../../app';

export const selectIsConnecting = ({ fathom }: RootState) =>
  fathom.isConnecting;

export const selectIsDisconnecting = ({ fathom }: RootState) =>
  fathom.isDisconnecting;

export const selectIsLoadingTranscripts = ({ fathom }: RootState) =>
  fathom.isLoadingTranscripts;

export const selectParticipants = ({ fathom }: RootState) =>
  fathom.participants;

export const selectTranscripts = ({ fathom }: RootState) => fathom.transcripts;
